import React from 'react';
import { Divider as AntDivider, DividerProps } from 'antd';

const Divider = (props: DividerProps) => {
  return <AntDivider style={{ margin: '14px 0' }} {...props} />;
};

export default Divider;
